import type { ComponentStyleConfig } from '@chakra-ui/react';

import { small } from '../typography';

const FormComponentStyle: ComponentStyleConfig = {
  baseStyle: {
    helperText: {
      ...small,
      color: 'secondary400',
    },
    requiredIndicator: {
      color: 'error400',
    },
  },
};

export default FormComponentStyle;
